var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yv-form-search',{ref:"formSearch",attrs:{"formSearch":_vm.formSearch,"inlineSearchAction":true,"enableExport":false},on:{"search":_vm.search}})}
var staticRenderFns = []

export { render, staticRenderFns }